<div  *ngIf="(branchZoneOverview)">

  <div class="wrapper">
    <div  class="divwrapper" *ngIf="TestSolarStartActive()">
      Solar
      <kendo-arcgauge style="display:block;height:90px;width:90px;"   [value]="solarsumstart.val" [scale]="{ min:0, max: solarsetpoint.val  }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(solarsumstart) }} <app-unit *ngIf="branchZoneOverview" [unit]="branchZoneOverview.solarsetpoint.variable.unit"></app-unit> </span>
        </ng-template>
      </kendo-arcgauge>

    </div>

    <div  class="divwrapper" *ngIf="TestRepeatStartActive()">
      Repeat Timer
      <kendo-arcgauge style="display:block;height:90px;width:90px;"  [value]="repeattimercount.val" [scale]="{ min: 0, max: repeattimesetpoint.val }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(repeattimercount) }} <app-unit *ngIf="branchZoneOverview" [unit]="branchZoneOverview.repeattimesetpoint.variable.unit"></app-unit></span>
        </ng-template>
      </kendo-arcgauge>

      <div *ngIf="(repeattimercount.val > repeattimesetpoint.val)"> WARNING

      </div>
      <div>
      {{ repeattimercount.val }} == {{ repeattimesetpoint.val }}
      </div>
    </div>

    <div  class="divwrapper" *ngIf="branchZoneOverview.solarpresent.constvalue.value">
      Solar Sum
      <kendo-arcgauge style="display:block;height:90px;width:90px;"  [value]="solarsummation.val" [scale]="{ min: 0, max: 1100 }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(solarsummation) }} <app-unit *ngIf="branchZoneOverview" [unit]="branchZoneOverview.solarsummation.variable.unit"></app-unit></span>
        </ng-template>
      </kendo-arcgauge>
    </div>
  </div>

  <hr/>
  <div class="wrappertank" *ngIf="ShowTank()">
    <div  class="divwrappertank" [style.background-color]="GetTankClass(sourcetank)"> Source {{ GetValue(sourcetank) }}   </div>
    <div  class="divwrappertank" [style.background-color]="GetTankClass(destinationtank)">  Dest {{ GetValue(destinationtank) }}   </div>
  </div>

  <hr/>
  <div id="running">
  Start Program &nbsp; {{ startprogram.val }}   <br/>
  Runs  {{ nrruntoday.val  }}  <br/>
  Waters  {{ watertoday.val  }}  <br/>
  </div>


</div>

